import { RefStructureUtil } from './util/ref-structure-util';
import { RefStructureInfo } from '../define/ref-structure-info';
import { GspDataTransferObject } from '../define/gsp-dto';
import { IGspDtoSerializeContext } from '../serialize-context/extension/i-gsp-dto-serialize-context';
import { IExtendStrucutreType } from '../define/data-type/i-extend-strucutre-type';

export class GspDtoConvertor {

    serialize(obj: Object, dto: GspDataTransferObject, ctxt: IGspDtoSerializeContext): void {
        obj['id'] = dto.id;
        obj['code'] = dto.code;
        obj['name'] = dto.name;
        obj['description'] = dto.description;
        obj['compile'] = dto.compile;

        //allStructuredTypes
        if (dto.allStructuredTypes) {
            let jarry = obj['allStructuredTypes'] = new Array<Object>();

            dto.allStructuredTypes.forEach(structureType => {
                var serializer = ctxt.getDataTypeSerializerFactory().get(structureType.kind);
                jarry.push(serializer.serialize(structureType, ctxt));
            });
        }

        obj['refStructureInfos'] = new Array<object>();
        if (dto.refStructureInfos) {
            dto.refStructureInfos.forEach(refInfo => {
                let refObj = RefStructureUtil.serialize(refInfo);
                obj['refStructureInfos'].push(refObj);
            })
        }

    }

    deserialize(dto: GspDataTransferObject, obj: Object, ctxt: IGspDtoSerializeContext): void {
        dto.id = obj['id'];
        dto.code = obj['code'];
        dto.name = obj['name'];
        dto.description = obj['description'];
        dto.compile = obj['compile'] as boolean;

        //allStructuredTypes
        if (obj['allStructuredTypes']) {
            dto.allStructuredTypes = new Array<IExtendStrucutreType>();
            obj['allStructuredTypes'].forEach(structureJobj => {
                var serializer = ctxt.getDataTypeSerializerFactory().get(structureJobj['kind']);
                dto.allStructuredTypes.push(serializer.deserialize(structureJobj, ctxt) as IExtendStrucutreType);
            });
        }

        //refStructures
        if (obj['refStructureInfos']) {
            dto.refStructureInfos = new Array<RefStructureInfo>();
            obj['refStructureInfos'].forEach(refObj => {
                let refInfo = RefStructureUtil.deserialize(refObj);
                dto.refStructureInfos.push(refInfo);
            })
        }

    }
}